import React, { Fragment, useEffect, useState } from "react";
import { graphql, useStaticQuery } from "gatsby";
import ImageView from "../components/ImageView";
import VideoPopup from "../components/VideoPopup";
import { animation } from "../utils";
import Footer from "./Footer";
import Header from "./Header";
import ScrollTop from "./ScrollTop";
import PreLoader from "./PreLoader";
import LandingHeader from "../components/tailwind/LandingHeader";
import { Script } from "gatsby";

const Layout = ({ children, header, footer, location }) => {
  const [loader, setLoader] = useState(true);

  useEffect(() => {
    animation();
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => setLoader(false), 2000);
    return () => clearTimeout(timer);
  });
  const { sanitySitesettings, allSanityBlog, allSanityLandingPage } =
    useStaticQuery(
      graphql`
        query {
          allSanityLandingPage {
            nodes {
              slug {
                current
              }
            }
          }
          sanitySitesettings {
            topBanner {
              enable
              welcome
              time
              social {
                icon
                url
              }
            }
            header {
              logo {
                alt
                asset {
                  gatsbyImageData(
                    formats: WEBP
                    fit: FILLMAX
                    placeholder: BLURRED
                  )
                }
              }
              logo2 {
                alt
                asset {
                  gatsbyImageData(
                    fit: FILLMAX
                    formats: WEBP
                    placeholder: BLURRED
                  )
                }
              }
              button {
                title
                linkType
                pdf {
                  asset {
                    url
                  }
                }
                link
                btnType
              }
              menu {
                parent {
                  label
                  link
                  type
                }
                childMenu {
                  type
                  link
                  label
                }
              }
            }
            footer {
              logo {
                alt
                asset {
                  gatsbyImageData(fit: FILLMAX, placeholder: DOMINANT_COLOR)
                }
              }
              about
              email
              location
              _rawCc
              menu {
                label
                link
                type
              }
              newsletter {
                enable
                heading
                button {
                  btnType
                  link
                  linkType
                  pdf {
                    asset {
                      url
                    }
                  }
                  title
                }
              }
              social {
                icon
                url
              }
            }
          }
          allSanityBlog(limit: 2, sort: { _createdAt: DESC }) {
            edges {
              node {
                title
                slug {
                  current
                }
                thumbnail {
                  alt
                  asset {
                    url
                  }
                }
                publishedAt
              }
            }
          }
        }
      `
    );
  // Check if current path matches any landing page slug
  const isLandingPage = allSanityLandingPage.nodes.some((node) => {
    const current = node?.slug?.current;
    if (!current || !location?.pathname) return false;
    const slugPath = `/${current}`;
    return (
      location.pathname === slugPath || location.pathname === `${slugPath}/`
    );
  });

  return (
    <Fragment>
      {/* {loader && <PreLoader />} */}
      {/* <VideoPopup /> */}
      <ImageView />
      {!isLandingPage ? (
        <Header
          header={header}
          data={sanitySitesettings?.header}
          topBanner={sanitySitesettings?.topBanner}
        />
      ) : (
        <LandingHeader data={sanitySitesettings?.header} />
      )}
      {children}
      {!isLandingPage && (
        <Footer
          footer={footer}
          data={sanitySitesettings?.footer}
          news={allSanityBlog}
        />
      )}
      <Script
        id="6senseWebTag"
        src="https://j.6sc.co/j/15d3c180-0a3b-4955-a8ed-b65ea575c2e3.js"
      />
      <ScrollTop />
    </Fragment>
  );
};
export default Layout;
